import React from 'react';
import PropTypes from 'prop-types';
import { Table, TableBody } from '@material-ui/core';
import { Typography } from 'kangarootime-ui';
import Header from './Header';
import Row from './Row';

const TableView = ({
  pendingPhotos,
  selectedPhotoIds,
  handlePhotoSelection,
  approvePhotos,
  rejectPhotos,
  viewPhotoInLightbox
}) => (
  <div className='flex-rows' style={{ flexWrap: 'wrap', marginTop: 16 }}>
    { pendingPhotos.length > 0
      ? <Table>
        <Header />
        <TableBody>
          {pendingPhotos.map(photo => (
            <Row
              photo={photo}
              key={photo.group_image_id}
              selectedPhotoIds={selectedPhotoIds}
              handlePhotoSelection={handlePhotoSelection}
              approvePhotos={approvePhotos}
              rejectPhotos={rejectPhotos}
              viewPhotoInLightbox={viewPhotoInLightbox}
            />
          ))}
        </TableBody>
      </Table>
      : <Typography type='subsectionHeader'>No photos require approval</Typography>
    }
  </div>
);

TableView.propTypes = {
  pendingPhotos: PropTypes.array,
  selectedPhotoIds: PropTypes.arrayOf(PropTypes.string),
  handlePhotoSelection: PropTypes.func,
  approvePhotos: PropTypes.func,
  rejectPhotos: PropTypes.func,
  viewPhotoInLightbox: PropTypes.func
};

export default TableView;
